import { get } from '@helpers'

const mapIds = <T extends { id: number }>(array: any[] | null = [], path: string = ''): T['id'][] => {
	return array ? array.map((item) => (path ? get(item, `${path}.id`) : item.id)) : []
}

export default mapIds
